var _circle, _circle2, _circle3, _circle4, _g, _g2, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9811,
    cy: 51.9811,
    r: 51.9811,
    fill: "#314DD8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9811,
    cy: 51.9811,
    r: 51.9811,
    fill: "#060C23"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.6686,
    cy: 60.0432,
    r: 33.3478,
    fill: "#2E293D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_28933",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9811,
    cy: 51.9811,
    r: 51.9811,
    fill: "#060C23"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_28933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7167 44.8483C83.1083 60.9778 69.575 73.5431 53.4656 72.9355C37.3563 72.3278 24.8079 58.7788 25.4162 42.6494C26.0246 26.5199 39.558 13.9546 55.6673 14.5622C71.7767 15.1699 84.3251 28.7189 83.7167 44.8483Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7582 43.2279L25.416 42.6492L24.5469 65.6913L39.8892 66.27L40.7582 43.2279Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6153 65.8071L16.8757 65.402L25.3 45.7216L27.6153 65.8071Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0321 84.0647L25.4436 82.647L24.5467 65.6916L67.6208 64.2396L63.0321 84.0647Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2028 101.483L39.0338 109.311L40.1057 80.8924L72.0497 69.0215L76.2028 101.483Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9336 78.6014L72.6141 74.427L81.8345 54.0075L61.7738 56.3275L60.9336 78.6014Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1475 29.8142V55.6349H25.9828V62.0901L32.4299 55.6349H58.2184V29.8142H21.1475Z",
    fill: "#435CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0066 45.9751V39.52L77.5595 45.9751H51.771V71.7958H88.842V45.9751H84.0066Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2186 44.3373H51.771V55.6346H58.2186V44.3373Z",
    fill: "#435CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3922 41.2534H11.7866V45.8647H16.3922V41.2534Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8797 16.2934H68.2935V22.8796H74.8797V16.2934Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6397 81.4667H38.1333V85.9731H42.6397V81.4667Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0152 50.2027L44.2198 53.2465L34.7771 53.8813L34.4446 48.9351C34.34 47.3786 34.7313 45.9625 35.6529 44.6845C36.54 43.4088 37.6948 42.4973 39.1197 41.9846C39.3917 41.8968 39.6638 41.809 39.9335 41.6866C40.2056 41.5989 40.4753 41.4765 40.7474 41.3887C41.9347 40.9615 42.859 40.2392 43.5894 39.2172C44.2853 38.1976 44.626 37.0628 44.5399 35.7831C44.4864 34.9875 44.2993 34.2705 43.9415 33.5996C43.5837 32.9288 43.1291 32.3687 42.5754 31.8847C42.0217 31.4008 41.3712 31.0276 40.6585 30.7628C39.9458 30.498 39.1755 30.4108 38.38 30.4642C36.8235 30.5689 35.544 31.1761 34.5415 32.2858C33.539 33.3955 33.0024 34.7172 33.0379 36.2783L23.526 36.9177C23.4211 34.8401 23.7083 32.9098 24.4175 31.0554C25.1267 29.201 26.1289 27.5701 27.4218 26.1281C28.7147 24.6862 30.236 23.5415 31.9834 22.6597C33.7309 21.7778 35.6423 21.2671 37.7176 21.1276C39.7929 20.9881 41.7924 21.2707 43.7136 21.9406C45.6003 22.6129 47.3004 23.6105 48.7769 24.901C50.2535 26.1916 51.435 27.7452 52.3538 29.5249C53.2749 31.3392 53.7879 33.2852 53.9297 35.3951C54.0367 36.9861 53.8646 38.5612 53.4111 40.0857C52.96 41.6448 52.2921 43.0795 51.4073 44.3898C50.5225 45.7001 49.4555 46.8837 48.2039 47.9059C46.9178 48.9305 45.5438 49.683 44.0152 50.2027ZM40.4017 66.741C39.7099 66.7875 39.0803 66.7256 38.476 66.523C37.8718 66.3204 37.3297 66.0094 36.8498 65.59C36.3699 65.1705 35.9892 64.675 35.6752 64.1402C35.3959 63.603 35.2134 62.9551 35.1692 62.2979C35.1227 61.6062 35.2169 60.9397 35.4195 60.3354C35.6221 59.7311 35.9677 59.1867 36.3871 58.7068C36.8088 58.2616 37.3044 57.8808 37.8738 57.5646C38.4456 57.2829 39.0588 57.1027 39.7506 57.0562C40.4078 57.012 41.0397 57.1085 41.644 57.3111C42.2483 57.5137 42.8249 57.8224 43.3048 58.2418C43.7824 58.6266 44.1631 59.1222 44.4817 59.7262C44.7633 60.2979 44.9459 60.9458 44.9924 61.6376C45.0389 62.3294 44.9424 62.9613 44.7375 63.531C44.5325 64.1007 44.1869 64.6451 43.7675 65.1249C43.3481 65.6048 42.8525 65.9856 42.2462 66.2696C41.6721 66.5166 41.0588 66.6968 40.4017 66.741Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_28933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.4603 77.9436C68.804 77.8878 68.2255 77.7342 67.6934 77.4454C67.1612 77.1565 66.7041 76.8045 66.3248 76.3547C65.9455 75.9049 65.6412 75.3919 65.4435 74.8532C65.2457 74.3145 65.1575 73.7155 65.2133 73.0591C65.2691 72.4028 65.4227 71.8244 65.749 71.2606C66.0378 70.7285 66.4244 70.2742 66.8742 69.8949C67.324 69.5157 67.834 69.2459 68.4073 69.0511C68.9806 68.8563 69.5796 68.7681 70.2359 68.8239C70.8577 68.8768 71.4362 69.0303 71.9654 69.3537C72.4975 69.6425 72.9892 69.9975 73.3685 70.4473C73.7478 70.8971 74.0521 71.4101 74.2469 71.9833C74.4417 72.5566 74.527 73.1901 74.4712 73.8465C74.4154 74.5028 74.2272 75.0783 73.9414 75.5759C73.6555 76.0735 73.2689 76.5278 72.8191 76.9071C72.3693 77.2863 71.8247 77.5532 71.2515 77.748C70.6782 77.9428 70.0821 77.9965 69.4603 77.9436ZM74.4848 67.5499L66.3323 66.8566L68.3165 37.7982L77.4017 38.5708L74.4848 67.5499Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7466 30.4249C13.8968 24.4402 18.1827 19.4396 23.1999 15.5484M28.083 12.2424C29.8306 11.2168 31.6407 10.31 33.5001 9.52623C34.8825 8.94351 36.292 8.42877 37.7232 7.98373",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3882 90.3859C79.2924 89.2628 81.1102 88.0055 82.828 86.6262C85.8403 84.2075 88.5451 81.4136 90.8686 78.3108",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_28933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.25664,
    height: 39.9041,
    fill: "white",
    transform: "translate(68.2129 37.7894) rotate(4.86114)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.0ad7b4d1d4b718dd1591b536e82205e1.svg";
export { ForwardRef as ReactComponent };